module.exports = __webpack_public_path__ + "static/banyoTop-a9d7e941ec9065d0a06dcebc7dbd33cf.jpg";